import { render } from "./AutorizarFormulario.vue?vue&type=template&id=4a440e35&scoped=true"
import script from "./AutorizarFormulario.vue?vue&type=script&lang=js"
export * from "./AutorizarFormulario.vue?vue&type=script&lang=js"

import "./AutorizarFormulario.vue?vue&type=style&index=0&id=4a440e35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a440e35"]])

export default __exports__